<script setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="bg-primary py-12">
    <div class="container mx-auto px-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-0 items-stretch">
        <!-- Left Side: Image -->
        <div class="w-full">
          <img
            src="@/../img/home/hand-compass.jpg"
            alt="Hand holding compass"
            class="w-full h-full object-cover"
          />
        </div>

        <!-- Right Side: Content with Proper Full Background -->
        <div class="bg-white p-8 md:p-12 flex flex-col justify-center w-full h-full">
          <h2 class="text-3xl md:text-4xl font-bold mb-6 text-center">{{ t("Twijfel je nog?") }}</h2>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Box 1 -->
            <div class="flex flex-col items-center text-center">
              <div class="text-3xl font-bold mb-2">1</div>
              <h3 class="text-lg md:text-xl font-semibold">{{ t("Ontdek Het Verschil!") }}</h3>
              <p
                class="text-sm md:text-base text-gray-600"
              >{{ t("Vraag het aan elke professional of instelling die al met ons werkt – zij vertellen je graag waarom Zorgblik het verschil maakt!") }}</p>
            </div>

            <!-- Box 2 -->
            <div class="flex flex-col items-center text-center">
              <div class="text-3xl font-bold mb-2">2</div>
              <h3 class="text-lg md:text-xl font-semibold">{{ t("Persoonlijk advies") }}</h3>
              <p
                class="text-sm md:text-base text-gray-600 text-center"
              >{{ t("Ontvang advies op maat van onze experts.") }}</p>
            </div>

            <!-- Box 3 (Full-width in small screens) -->
            <div class="col-span-1 md:col-span-2 flex flex-col items-center text-center">
              <div class="text-3xl font-bold mb-2">3</div>
              <h3 class="text-lg md:text-xl font-semibold">{{ t("Vragen?") }}</h3>
              <p
                class="text-sm md:text-base text-gray-600 text-center md:text-left"
              >{{ t("Stuur een bericht naar mailto:info@zorgblik.nl.") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>